import { Stack, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { urlGetEstimateById } from '../../helpers';
import useFetch from '../../hooks/useFetch';
import CircularProgress from '@mui/material/CircularProgress';
import '../work/style.css';
import { ViewContactData } from '../work/components/ViewContactData';
import ViewServiceWork from '../work/components/ViewServiceWork';
import { ViewRentsWork } from '../work/components/ViewRentsWork';
import { ViewConditionWork } from '../work/components/ViewConditionWork';
import { dateFormmater } from '../../helpers';

export const EstimateViewData = () => {

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const { data } = useFetch( urlGetEstimateById+'?id=' + searchParams.get('id'));
    const { addressWork, contact, status, client, characteristics, changes, rents, product, rentAbatementDate, dateRentalEntry, dateGetMaterial, billNumber } = data ? data[0] : {};


    return (
        <Stack width='100%' alignItems='center' >
            {
                data
                    ?
                    <Stack width='95%' mt='2rem' className='viewPage' mb='2rem' >
                        <Typography variant="h4" color="primary" textAlign='center'><b>Presupuesto:</b> {addressWork}</Typography>
                        <ViewContactData billNumber={billNumber} status={status} dataContact={JSON.parse(client?.contacts).filter(d => d.contactName === contact)[0]} />

                         <Typography variant="h6" color="primary" textAlign='center'>Condiciones</Typography>
                        <ViewConditionWork data={data[0]} />

                        <Typography variant="h6" color="primary" textAlign='center'>Servicios</Typography>
                        <ViewServiceWork services={product} />

                        <Typography variant="h6" color="primary" textAlign='center'>Alquileres</Typography>
                        <ViewRentsWork rents={rents} />

                        <Typography variant="h6" color="primary" textAlign='center'>Otros</Typography>
                        <Stack >
                            {characteristics && <Typography variant='subtitle1'><b>Caracteristicas:</b> {characteristics}</Typography>}

                            {changes && <Typography variant='subtitle1'><b>Modificaciones: </b> {changes}</Typography>}
                            {dateRentalEntry && <Typography variant='subtitle1'><b>Fecha de alta del alquiler: </b> {dateFormmater(dateRentalEntry)}</Typography>}
                            {rentAbatementDate && <Typography variant='subtitle1'><b>Fecha de baja del alquiler: </b> {dateFormmater(rentAbatementDate)}</Typography>}
                            {dateGetMaterial && <Typography variant='subtitle1'><b>Fecha de recogida de material: </b> {dateFormmater(dateGetMaterial)}</Typography>}
                        </Stack> 
                    </Stack>
                    : <CircularProgress />
            }
        </Stack>
    )
}